import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// IMPORT PACKAGE REFERENCES

import { addDevice } from '../State/Actions/DeviceActions';


// COMPONENT

class AddDevice extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            deviceId : '',
        }

        this.handleChange = this.handleChange.bind(this);
    }

    addDevice() {
        // If a pharmacy ID is present then the new device should be attached to the pharmacy.
        this.props.addDevice(this.state.deviceId, this.props.pharmacyId);
        this.setState({deviceId: ''});
        this.props.handleAdd();
    }

    handleChange(event) {
        this.setState({deviceId: event.target.value});
    }


    render() {
        return (
            <div className="modal fade" id="addDeviceModal" role="dialog" aria-labelledby="addDeviceModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <Fragment>
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Add Device</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                        <div className="form-group">
                            <label>Device UUID</label>
                            <input value={this.state.deviceId} onChange={this.handleChange} type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter device UUID"/>
                            <small id="emailHelp" className="form-text text-muted">Enter the UUID associated with your device.</small>
                        </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button onClick={() => this.addDevice()} data-dismiss="modal" type="button" className="btn btn-primary">Add Device</button>
                        </div> 
                    </Fragment>
                    </div>
                </div> 
            </div>
        )
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { } = state.devicesReducer;
  return { };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({ addDevice }, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(AddDevice);


// EXPORT COMPONENT

export { hoc as AddDevice };